import http from './httpService'

export function getAutomationLogs(store, pageno) {
  return http.get(`/automation/logs?store=${store}&pageno=${pageno}`)
}

export function toggleAutomation(store, status) {
  return http.post(`/automation/config/${store.toUpperCase()}`, {
    config: { email: status }
  })
}

export function getAutomationStatus(store) {
  return http.get(`/automation/config/${store.toUpperCase()}`)
}
